import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown-close",
  "use": "icon-dropdown-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-dropdown-close\"><path d=\"M4 10h8L8 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol